<template>
  <SingleClass />
</template>

<script>
import SingleClass from '@/components/content/classes/EditSelectedClass.vue'

export default {
  name: 'ContentClassVerification',
  components: { SingleClass }
}
</script>

<style scoped>

</style>
